import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import { Button, Icon } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkSquare } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
var button = {
    initial: {
        opacity: 0,
        marginTop: '1rem'
    },
    animate: {
        opacity: 1,
        marginTop: '0'
    }
};
var background = {
    initial: {
        filter: 'brightness(1)'
    },
    animate: {
        filter: 'brightness(0.75)'
    }
};
export default function PanelHoverWrapper(param) {
    var children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ _jsxs(motion.div, {
        initial: "initial",
        animate: "initial",
        whileHover: "animate",
        style: {
            height: '100%',
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                variants: background,
                transition: {
                    type: 'spring',
                    stiffness: 400,
                    damping: 40
                },
                style: {
                    height: '100%',
                    position: 'relative'
                },
                children: children
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                variants: button,
                transition: {
                    duration: 0.25
                },
                style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    backgroundColor: "backgroundInverse !important",
                    variant: "cta",
                    size: "sm",
                    onClick: onClick,
                    boxShadow: "2xl",
                    leftIcon: /*#__PURE__*/ _jsx(Icon, {
                        as: FontAwesomeIcon,
                        icon: faExternalLinkSquare
                    }),
                    zIndex: "1",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "wZ6Rtf",
                        defaultMessage: "Try it out"
                    })
                })
            })
        ]
    });
}
